import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api objects
export const getAllListHashTag = () => {
    return api.makeAuthRequest({
        url: `/hashtag/intask`,
        method: 'GET',
    })
}
